import {
  CameraConnectionIssueReason,
  captureCameraEvent,
  EXAM_EVENTS,
} from 'src/services/posthogEvents';
import { reportCameraConnectionIssue } from 'src/services/reportCameraConnectionIssue';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CameraConnection from 'src/models/Camera/CameraConnection';

import { captureError } from 'src/utils/errorReporting';

export default function useCancelCaptureImages() {
  const { setIsCanceling, leftUrl, rightUrl } = useRemoteBoundStore();

  const handleCancelCapture = async () => {
    try {
      setIsCanceling(true);
      captureCameraEvent(EXAM_EVENTS.IMAGING_CANCEL_REQUESTED, {
        had_left_image: Boolean(leftUrl),
        had_right_image: Boolean(rightUrl),
      });
      await CameraConnection.getInstance().existCaptureProcess();
      captureCameraEvent(EXAM_EVENTS.IMAGING_CANCELLED, {
        had_left_image: Boolean(leftUrl),
        had_right_image: Boolean(rightUrl),
      });
    } catch (error) {
      captureError(error, 'Cancel capture images failed');
      reportCameraConnectionIssue(CameraConnectionIssueReason.COMMAND_FAILED);
    }
  };

  return {
    handleCancelCapture,
  };
}
